import React, { Fragment, useEffect, useState } from 'react';
import { Table as BootstrapTable } from 'react-bootstrap';
import { useTable } from 'react-table';
import styled from 'styled-components';

type ColumnProps = {
    Header?: string;
    accessor?: string;
    Cell?: object;
};

type Props = {
    column: ColumnProps[];
    data: any;
};

const OverviewTable = ( props: Props ) => {
    const { column, data } = props;
    const [columns]: any = useState(column);
    // const [stateData, setStateData]: any = useState(data);

    useEffect(() =>  {
        // setColumns(column);
        // setStateData(Array(data));
    }, []);

    const {
        getTableProps,
        getTableBodyProps,
        rows,
        prepareRow,
    } = useTable({ columns, data })

    return (
        <OverviewTableWithStyled>
            <BootstrapTable className="table-light" {...getTableProps()}>
                <TBody {...getTableBodyProps()}>
                    { rows.length ?
                        rows.map((row: any, i: number) => {
                            prepareRow(row);
                            return (
                                <Fragment key={i}>
                                    {row.cells.map((cell: any, index: number) => {
                                        return (
                                            <TR key={index}>
                                                <TH>{cell.render('Header')}</TH>
                                                <TD {...cell.getCellProps()}>{cell.render('Cell')}</TD>
                                            </TR>
                                        )
                                    })}
                                </Fragment>
                            );
                        })
                    : <TR><TD colSpan={columns.length}>データがありません</TD></TR> }
                </TBody>
            </BootstrapTable>
        </OverviewTableWithStyled>
    );
}

const OverviewTableWithStyled = styled.div`
`;
const TBody = styled.tbody`
`;
const TR = styled.tr`
`;
const TH = styled.th`
`;
const TD = styled.td`
`;

export default OverviewTable;